import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Grid,
  Typography,
  makeStyles,
  IconButton,
  Tooltip,
  Avatar,
} from "@material-ui/core";
import Tables from "../tables/Tables";
import PageTitle from "../../components/PageTitle/PageTitle";
import Axios from "axios";
import ApiConfig from "../../config/ApiConfig";
import moment from "moment";
import CircularProgressWithBackdrop from "../../components/Loader/loader";
import { Visibility } from "@material-ui/icons";
import { UserContext } from "../../context/User";

const useStyles = makeStyles({
  btn: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: "#00d4ff",
    color: "#000",
  },
  btn1: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    background: "#00d4ff",
    marginTop: "21px",
  },

  searchPlaceholder: {
    color: "#004AAD",
    "& .MuiOutlinedInput-inputAdornedEnd": {
      color: "gray",
      fontSize: "13px",
      padding: "14px 1px 12px 10px",
    },
  },

  btnGroup: {
    background: "white",
    boxShadow:
      "0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
  },
  forminput: {
    "& .textFeilds": {
      border: "1.16355px solid #fff",
      borderRadius: "3.49065px !important",
    },
    "& .limitTextField": {
      width: "100%",
      maxWidth: "100px",
      border: "1.16355px solid #fff",
      borderRadius: "3.49065px !important",
      alignSelf: "end",
      marginRight: "9px",
    },
    "& .MuiSelect-icon": {},
  },
  forminputDate: {
    width: "100%",
    "& .MuiFormControl-marginDense": {
      // border: "1.16355px solid #fff",
      // borderRadius: "3.49065px !important",
      margin: "0px",
      width: "100%",
    },
    "& .MuiInputBase-input": {},
  },
  // FromTable1: {
  //   Date: {
  //     color: "#004AAD",
  //   },
  // },

  selectPlaceholder: {
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      color: "gray",
      fontSize: "13px",
    },
  },
  DialogPaper: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "420px !important",
      width: "100% !important",
      padding: "15px 30px",
    },
  },
});

function TicketRaise() {
  const history = useHistory();
  const classes = useStyles();
  const [fromDate, setfromDate] = useState(null);
  const [toDate, settoDate] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [allTest, setallTest] = useState();
  const [size, setSize] = useState(0);
  const [loader, setLoader] = useState(false);
  const ContextId = useContext(UserContext);
  const [ticketsMap, setTicketsMap] = useState({});
  const epochFrom = new Date(fromDate);
  const epochTo = new Date(toDate);
  epochFrom.setHours(0, 0, 0, 0);
  epochTo.setHours(23, 59, 59, 599);

  function TruncatedTextNormal({ text, maxLength }) {
    const truncatedText =
      text?.length > maxLength ? `${text?.slice(0, maxLength)}...` : text;

    return (
      <Tooltip title={text?.length > maxLength ? text : ""} placement="top">
        <span style={{ whiteSpace: "nowrap" }}>{truncatedText}</span>
      </Tooltip>
    );
  }



// const handleViewTicket = (id) => {
//   const data = allTest[id];

//   // update context
//   ContextId.handleContentId(data);

//   // optional: persist for refresh
//   localStorage.setItem("ticketData", JSON.stringify(data));

//   history.push({
//     pathname: "/app/viewTicket",
//   });
// };

const handleViewTicket = (ticketData) => {
  console.log("Viewing ticket:", ticketData);
  
  // update context
  ContextId.handleContentId(ticketData);

  // optional: persist for refresh
  localStorage.setItem("ticketData", JSON.stringify(ticketData));

  history.push({
    pathname: "/app/viewTicket",
  });
};

 const column = [
    {
      name: "serialNumber", // Custom column name
      label: "Sr.No.", // Column header label
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          // Calculate the serial number based on the row index
          const rowIndex = page * pageSize + tableMeta.rowIndex + 1;
          return rowIndex;
        },
      },
    },
    // {
    //   name: "testId",
    //   label: "Test ID",
    //   options: {
    //     display: false,
    //   },
    // },
    {
      name: "uniqueTicketId",
      label: "Ticket Id",
      options: {
        display: false,
      },
    },
    {
      name: "uniqueTicketId",
      label: "Ticket Id",
    },
    {
      name: "testName",
      label: "Test Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <TruncatedTextNormal text={value} maxLength={20} />
            </>
          );
        },
      },
    },
    {
      name: "createdAt",
      label: "Created At",
      options: {
        filter: true,

        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <>{moment(value).format("DD MMMM YYYY HH:mm")}</>;
        },
      },
    },
    {
      name: "status",
      label: "Status",
    },
    {
      name: "reason",
      label: "Reason",
      // options: {
      //   filter: false,

      //   empty: true,
      //   customBodyRender: (value, tableMeta, updateValue) => {
      //     return (
      //       <div style={{ display: "flex", justifyContent: "center" }}>
      //         <Avatar src={value} />{" "}
      //       </div>
      //     );
      //   },
      // },
    },

    // {
    //   name: "Action",
    //   label: "Action / View",
    //   options: {
    //     filter: true,

    //     empty: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       console.log("afkhaksfhajklfhalshfjlakf", {
    //         value,
    //         tableMeta,
    //         updateValue,
    //       });
    //       return (
    //         <div className={classes.meanbtn} style={{ display: "flex" }}>
    //           <IconButton
    //             onClick={(e) => {
    //               // history.push({
    //               //   pathname: "/app/viewTicket",
    //               //   state: { ticketData: tableMeta },
    //               // });
    //                 console.log("Table Meta Data", tableMeta);
    //               // handleViewTicket(tableMeta.rowData[0]);
    //               handleViewTicket(tableMeta.rowIndex);
    //               console.log("Context ID", tableMeta.rowData[1]);

    //               // ContextId.handleContentId(tableMeta.rowData[1]); 
    //             }}
    //           >
    //             <Visibility style={{ color: "blue" }} />{" "}
    //           </IconButton>
    //         </div>
    //       );
    //     },
    //   },
    // },
    {
  name: "Action",
  label: "Action / View",
  options: {
    filter: true,
    empty: true,
    customBodyRender: (value, tableMeta, updateValue) => {
      // Get the uniqueTicketId from the row data
      const uniqueTicketId = tableMeta.rowData[1];
      
      // Get the complete ticket data from the map
      const ticketData = ticketsMap[uniqueTicketId];
      
      return (
        <div className={classes.meanbtn} style={{ display: "flex" }}>
          <IconButton
            onClick={(e) => {
              handleViewTicket(ticketData);
            }}
          >
            <Visibility style={{ color: "blue" }} />{" "}
          </IconButton>
        </div>
      );
    },
  },
}
  ];

  //get-all-test API

  // const getAllRaiseTicketList = async () => {
  //   try {
  //     setLoader(true);
  //     // const res = await axios.get(ApiConfig.getAllTickets, {
  //     //   headers: {
  //     //     Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
  //     //   },
  //     // });

  //     console.log("fakshfkjsahfjkashfahafsjasfgasgasg", {
  //       method: "GET",
  //       url: ApiConfig.getAllTickets,
  //       headers: {
  //         Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
  //       },
  //     });

  //     const res = await Axios({
  //       method: "GET",
  //       url: ApiConfig.getAllTickets,
  //       headers: {
  //         Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
  //       },
  //     });

  //     console.log("API REPSONSE", res?.data?.data);

  //     if (res?.status === 200) {
  //       const reversedTickets = res?.data?.data; 
  //       setallTest(reversedTickets);
  //       console.log("Responseeeeeee", res);
  //     }
  //   } catch (error) {
  //     console.error("Error in fetching tickets:", error);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  // const AllTest = async () => {
  //   setLoader(true);
  //   if (type === "TL") {
  //     try {
  //       const res = await Axios({
  //         method: "GET",
  //         url: ApiConfig.getallTest,
  //         headers: {
  //           Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
  //         },
  //       });
  //       if (res.data.status === 200) {
  //         setallTest(res?.data?.data?.list);
  //         console.log(
  //           "afskhfjkasfjkasfjkasgfjkasgfahks",
  //           res?.data?.data?.list
  //         );
  //         setLoader(false);
  //         setSize(res?.data?.data?.count);
  //       } else {
  //         setLoader(false);
  //       }
  //     } catch (error) {
  //       setLoader(false);
  //     }
  //   } else if (type === "TR") {
  //     try {
  //       const res = await Axios({
  //         method: "GET",
  //         url: ApiConfig.getallTestReport,
  //         headers: {
  //           Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
  //         },
  //         params: {
  //           page: page,
  //           fromDate: fromDate ? epochFrom.getTime() : null,
  //           toDate: toDate ? epochTo.getTime() : null,

  //           search: searchValue,
  //           pageSize: pageSize,
  //           matchingStatus: status,
  //           testStatus: testStatus,
  //         },
  //       });

  //       if (res.data.status === 200) {
  //         setallTest(res?.data?.data?.list);
  //         console.log(
  //           "afskhfjkasfjkasfjkasgfjkasgfahks",
  //           res?.data?.data?.list
  //         );
  //         setLoader(false);
  //         setSize(res?.data?.data?.count);
  //       } else if (res.data.status === 205) {
  //         setallTest([]);
  //         setLoader(false);
  //         setSize([]);
  //       }
  //     } catch (error) {
  //       setLoader(false);
  //     }
  //   }
  // };


  const getAllRaiseTicketList = async () => {
  try {
    setLoader(true);
    const res = await Axios({
      method: "GET",
      url: ApiConfig.getAllTickets,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
      },
    });

    if (res?.status === 200) {
      const reversedTickets = res?.data?.data; 
      setallTest(reversedTickets);
      
      // Create a map of tickets by their uniqueTicketId for easy lookup
      const map = {};
      reversedTickets.forEach(ticket => {
        map[ticket.uniqueTicketId] = ticket;
      });
      setTicketsMap(map);
    }
  } catch (error) {
    console.error("Error in fetching tickets:", error);
  } finally {
    setLoader(false);
  }
};

  useEffect(() => {
    getAllRaiseTicketList();
  }, []);

  return (
    <>
      <PageTitle title="Ticket Raise" />
      <Grid
        container
        spacing={2}
        style={{ justifyContent: "right", alignItems: "center" }}
      >
        <Grid item xs={12}>
          <Typography style={{ marginBottom: "20px", fontSize: "1rem" }}>
            {" "}
            Ticket Raise List
          </Typography>

          {loader ? (
            <CircularProgressWithBackdrop open={loader} />
          ) : (
            <div id="muiTableData">
              <Tables data={allTest} column={column} size={size} />
            </div>
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default TicketRaise;
